import React from 'react';
import { BUILD_ENVIRONMENT } from 'Settings';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import ConnectedFormattedImage from 'Containers/ConnectedFormattedImage';

import Button from 'Components/Button';
import styles from './HomepageHero.scss';
import img from './2020_Hero_CommonSenseMedia.png';
import { ROUTES } from 'Settings/route-strings';

class HomepageHero extends React.PureComponent {
  render() {
    const buttonProps = {
      label: <ConnectedFormattedMessage id="homepage_hero.purchase_now_cta" />,
      route: ROUTES.PRICING,
      buttonType: 'primary',
      newWindow: true,
      additionalClasses: ' Button--homepage-hero',
    };
    if (BUILD_ENVIRONMENT === 'demo') {
      buttonProps.externalLink = 'https://schools.tinybop.com/free-trial';
      delete buttonProps.route;
    }

    return (
      <div className="HomepageHero">
        <div className="HomepageHero__container">
          <div className="HomepageHero__copy">
            <div className="HomepageHero__slug">
              <ConnectedFormattedMessage id="product.name" />
            </div>
            <h2 className="HomepageHero__headline">
              <ConnectedFormattedMessage id="product.tagline" />
            </h2>
            <Button {...buttonProps} />
          </div>
          <ConnectedFormattedImage
            className="HomepageHero__graphic"
            src={img}
            altId="homepage_hero.graphic.alt"
          />
        </div>
      </div>
    );
  }
}

export default HomepageHero;
